import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEdit,
  faDownload,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { get } from 'helpers/requests';
import { API, BASE_URL } from '../CONST';
import { cleanData, getData, putData } from '../redux-store/actions/index';
import {
  headerOperation,
  cellNumOperation,
  cellOperation,
} from '../helpers/tables';
import DetalleUso from './DetalleUso';
import DetalleMovimiento from './DetalleLinea';
import StateAlert from './UI/StateAlert';
import BaseTable from './UI/BaseTable';
import Icon from './UI/Icon';
import { fileDownload } from '../helpers/helpers';
import isUserHasProfile from '../helpers/profileValidator';
import { GARANTIA_EDIT_WRITE, GARANTIA_EXPOSICION_MAXIMA_WRITE } from '../helpers/profilePermission';

const moment = require('moment');

function mapDispatchToProps(dispatch) {
  return {
    getMovimientos: client => dispatch(getData(client)),
    resetData: client => dispatch(cleanData(client)),
    approveMovimiento: request => dispatch(putData(request)),
  };
}

function isUserHasProfileByMovementType (mov) {
    if (mov.tipo.nemotecnico === 'exposicion-maxima'){
      return isUserHasProfile(GARANTIA_EXPOSICION_MAXIMA_WRITE);
    }
    return isUserHasProfile(GARANTIA_EDIT_WRITE);
  };

class MovimientoListDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: null,
      loading: false,
      modalOpen: false,
      movimientosList: false,
    };
    this.table = React.createRef();
    this.handleModal = this.handleModal.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { handleUpdate, movimiento, update, success } = this.props;
    if (prevProps.movimiento.label !== movimiento.label && movimiento) {
      this.fetchData(this.table.current.state);
    }
    if (prevProps.success !== success && success) {
      this.handleSuccess();
    }
    if (prevProps.update !== update && update) {
      this.fetchData(this.table.current.state);
      handleUpdate(false);
    }
  }

  handleModal(e, instance) {
    e.preventDefault();
    this.setState({
      detail: instance,
    });
    this.toggleModal();
  }

  handleSuccess() {
    const { resetData } = this.props;
    this.setState({ loading: false });
    resetData();
  }

  toggleModal() {
    const { modalOpen } = this.state;
    if (modalOpen) {
      this.setState({
        modalOpen: false,
        detail: null,
      });
    } else {
      this.setState({
        modalOpen: !modalOpen,
      });
    }
  }

  fetchData(state) {
    const { movimiento, id, isGrupo } = this.props;
    this.setState({ loading: true });
    const rutaMovimientos = isGrupo ? API.movimientosGrupo : API.movimientos;
    const query = `?linea_garantia${isGrupo ? '_grupo' : ''}_id=${id}&tipo_id=${movimiento.tipo_id}`;
    const url = `${BASE_URL}${rutaMovimientos}${query}&page=${state.page + 1}`;
    get(url).then((response) => {
      this.setState({
        movimientosList: response,
        loading:false,
      })

    })
  }

  render() {
    const {
      handleEdit,
      movimiento,
      loginIdToken,
      setActiveMovement,
      afianzado,
      isGrupo,
    } = this.props;
    const { detail, loading, modalOpen, movimientosList } = this.state;
    const columns = [
      {
        Header: headerOperation('Fecha'),
        id: 'fecha',
        accessor: i => cellOperation(moment(i.fecha).format('DD/MM/YYYY')),
        maxWidth: 160,
      },
      {
        Header: headerOperation('Tipo movimiento'),
        id: 'tipo_cambio',
        accessor: i => cellOperation(i.tipo_cambio.descripcion),
        sortable: false,
        maxWidth: 140,
      },
      {
        Header: headerOperation('Monto (UF)'),
        headerStyle: {
          paddingRight: '3%',
        },
        id: 'monto',
        style: {
          paddingRight: '3%',
        },
        accessor: i => cellNumOperation(i.cambio_monto),
        sortable: false,
        minWidth: 120,
      },
      {
        Header: headerOperation('Balance (UF)'),
        headerStyle: {
          paddingRight: '3%',
        },
        id: 'balance',
        style: {
          paddingRight: '3%',
        },
        accessor: i =>
          cellNumOperation(i.balance[movimiento.nemotecnico], 'right'),
        sortable: false,
        minWidth: 120,
      },
      {
        Header: headerOperation('Estado'),
        id: 'borrador',
        accessor: i => cellOperation(<StateAlert isBorrador={i.borrador} />),
        width: 160,
        sortable: false,
      },
      {
        Header: headerOperation('Acciones'),
        id: 'acciones',
        headerStyle: {
          paddingLeft: '5%!important',
        },
        accessor: i =>
          !loading &&
          cellOperation(
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Icon
                handleOnClick={e => this.handleModal(e, i)}
                id={`detalle-${i.id}`}
                isDisabled={i.borrador && isUserHasProfileByMovementType(i)}
                placement="left"
                tooltipText={
                  <span className="detalle-tooltip">Ver Detalle</span>
                }
              >
                <FontAwesomeIcon icon={faEye} className="table-link" />
              </Icon>
              {i.tipo.nemotecnico === 'linea' && (
                <>
                  &nbsp;&nbsp;
                  <Icon
                    handleOnClick={() => {
                      const id = i.contrato_id;
                      const downloadUrl = `${BASE_URL}${API.download}/`;
                      fileDownload(downloadUrl, id);
                    }}
                    id={`activate-${i.id}`}
                    isDisabled={!i.contrato_id}
                    placement="left"
                    tooltipText={
                      <span className="activate-tooltip">Descargar</span>
                    }
                  >
                    <FontAwesomeIcon icon={faDownload} className="table-link" />
                  </Icon>
                </>
              )}
              &nbsp;&nbsp;
              {isUserHasProfileByMovementType(i) && (
                <Icon
                  handleOnClick={e => handleEdit(e, i, movimiento)}
                  id={`edit-${i.id}`}
                  isDisabled={!i.borrador}
                  placement="left"
                  tooltipText={<span className="delete-tooltip">Editar</span>}
                >
                  <FontAwesomeIcon icon={faEdit} className="table-link" />
                </Icon>
              )}
              &nbsp;&nbsp;
              {isUserHasProfileByMovementType(i) && (
                <Icon
                  handleOnClick={e => setActiveMovement(e, i)}
                  id={`delete-${i.id}`}
                  isDisabled={!i.borrador}
                  placement="left"
                  tooltipText={<span className="delete-tooltip">Borrar</span>}
                >
                  <FontAwesomeIcon icon={faTrash} className="table-link" />
                </Icon>
              )}
            </div>,
            'center actions',
          ),
        width: 250,
        sortable: false,
      },
    ];
    const isUso = movimiento.label === 'Cúmulo';
    return (
      <div className="movimientos-container">
        <div className="movimientos-title">
          <h5>
            {`Detalle ${!isUso ? 'Movimientos' : ''} ${movimiento.label}`}
          </h5>
        </div>
        <div className="movimientos-table">
          <BaseTable
            className="movimientos-list"
            columns={columns}
            data={movimientosList.results}
            loading={loading}
            onFetchData={this.fetchData}
            pages={Math.ceil(movimientosList.count / 20)}
            resizable={false}
            resultCount={movimientosList.count}
            showPagination
            tableRef={this.table}
          />
        </div>
        {detail !== null &&
          (isUso ? (
            <DetalleUso
              handleModal={this.handleModal}
              id={detail.id}
              modalOpen={modalOpen}
            />
          ) : (
            <DetalleMovimiento
              movimientoId={detail.id}
              afianzado={afianzado}
              loginIdToken={loginIdToken}
              handleModal={this.handleModal}
              modalOpen={modalOpen}
              isGrupo={isGrupo}
            />
          ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  clientTable: state.clients.clientTable,
  success: state.clients.successMessage,
  loginIdToken: state.login.id_token,
});

MovimientoListDetail.propTypes = {
  handleEdit: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  movimiento: PropTypes.shape({
    borrador: PropTypes.bool,
    label: PropTypes.string,
    tipo_id: PropTypes.number,
    nemotecnico: PropTypes.string,
  }).isRequired,
  id: PropTypes.number.isRequired,
  resetData: PropTypes.func.isRequired,
  setActiveMovement: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  update: PropTypes.bool.isRequired,
  loginIdToken: PropTypes.string.isRequired,
  afianzado: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    rut: PropTypes.string,
  }),
  isGrupo: PropTypes.bool,
};

MovimientoListDetail.defaultProps = {
  afianzado:{},
  isGrupo: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MovimientoListDetail);
